import { render } from "./CursoForm.vue?vue&type=template&id=c3e1738c&scoped=true"
import script from "./CursoForm.vue?vue&type=script&lang=js"
export * from "./CursoForm.vue?vue&type=script&lang=js"

import "./CursoForm.vue?vue&type=style&index=0&id=c3e1738c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c3e1738c"]])

export default __exports__